var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import { Tooltip } from '@hn-ui/tooltips';
import { styled } from 'styled-components';
import { CheckboxWithLabel } from '../../../../../../components/CheckboxWithLabel';
var ScCheckbox = styled(CheckboxWithLabel).withConfig({ displayName: "ScCheckbox", componentId: "sc-v05o5i" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-weight: 400;\n"], ["\n  font-weight: 400;\n"])));
var SkillCheckbox = function (_a) {
    var skill = _a.skill, disabled = _a.disabled, tooltipText = _a.tooltipText, props = __rest(_a, ["skill", "disabled", "tooltipText"]);
    var ref = useRef(null);
    var _b = useState(null), checkboxNode = _b[0], setNode = _b[1];
    useEffect(function () {
        if (ref.current) {
            setNode(ref.current.children[0].children[0]);
        }
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx(ScCheckbox, __assign({}, props, { ref: ref, text: skill.name, subtitle: skill.category, disabled: disabled }), void 0), disabled && checkboxNode && (_jsx(Tooltip, { maxWidth: 180, content: tooltipText, virtualElement: {
                    getBoundingClientRect: function () { return checkboxNode.getBoundingClientRect(); },
                } }, void 0))] }, void 0));
};
export { SkillCheckbox };
var templateObject_1;
